import { render, staticRenderFns } from "./wjSubTable.vue?vue&type=template&id=0c039df2"
import script from "./wjSubTable.vue?vue&type=script&lang=js"
export * from "./wjSubTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports